import { useEffect, useState, useContext } from 'react';
import {  NavLink } from "react-router-dom";

import { getLabConfig, getSystemMsg } from '../../utils/api';

import LabIDContext from '../../store/LabIDContext';
import OrderClasses from './Order.module.css';

const OrderComplete = ({ reqNumber, token, orderinfo }) => {
	const labid = useContext(LabIDContext);
	const [webURL, setWebURL] = useState([]);
	const [msg,setMsg] = useState('');
	useEffect(() => {
		async function fetchMessage() {
		  try {
			const data = await getSystemMsg("OrderComplete");
			setMsg(data);
		  } catch (err) {
			console.error("Failed to fetch message:", err);
			setMsg("Thank you for trusting us!"); // fallback message
		  }
		}
		fetchMessage();
	}, []);
	const [locs,setLocs] = useState('');
	useEffect(() => {
		async function fetchLocations() {
		  try {
			const data = await getSystemMsg("Pick a Location");
			setLocs(data);
		  } catch (err) {
			console.error("Failed to fetch locations:", err);
			setLocs("Select a convenient location where you can have your specimen collected for testing.xx"); // fallback message
		  }
		}
		fetchLocations();
	}, []);
	useEffect(() => {
        async function fetchLabSetting() {
            const webURL = await getLabConfig('WEBSERVER');
            setWebURL(webURL);
        }
        fetchLabSetting();
    }, []);
	const ReqURL = webURL + labid + '/lpi3/?event=dtc.DTC&reqnumlist=';
return (
    <div className={OrderClasses.orderConfirmation}>
      {/* Left Section */}
	  <div className={OrderClasses.orderLeft}>
        <img
          alt="check mark"
          className={OrderClasses.iconImage}
          src="../images/Icons/Checkmark.png"
        />
        <h1>Order received!</h1>
		<p className={OrderClasses.thanksText}>
		{msg && Object.keys(msg).length > 0 ? (
					  <div>{msg}</div>
					) : (
					  <div>Thank you for trusting us!</div>
					)}
        </p>
		<p className={OrderClasses.subtext}>Credit card payment sucessful.  </p>
        <p className={OrderClasses.subtext}>Your order has been sent to the lab.</p>
      </div>

      {/* Right Section */}
      <div className={OrderClasses.orderRight}>
        <a
          href={`${ReqURL}${reqNumber}&token=${token}`}
          target="_prtReq"
          rel="noopener noreferrer"
		  className={OrderClasses.actionBox}
        >
          <strong>Print Order Requisition</strong>
          <span>
            Generate a printable copy of your order form to bring with you or keep for your records.
          </span>
        </a>

		{locs && Object.keys(locs).length > 0 ? (
			<NavLink
			  to="../drawLocations"
			  state={{ orderInfo: orderinfo }}
			  className={OrderClasses.actionBox}
			>
			  <strong>Pick a Location for Specimen Collection</strong>
			  <span>
			  {locs}
			  </span>
			</NavLink>
		) : null }
      </div>
    </div>	   
	);
};

export default OrderComplete;
